import React from 'react';
import Tooltip from 'rc-tooltip';

import classNames from 'classnames';
import {
  Flex, Text, Box, AssigneeLabel, ActionStatus,
} from './components';
import * as S from './styles';
import { capitializeString } from '../../assets/js/utils';

const actionStatusNameMapping = {
  completed: 'Complete',
  not_started: 'Not started',
  locked: 'Marked as complete'
};

function AssigneeList({ assignees, offer }) {
  const [expand, setExpand] = React.useState(false);
  let names = [];
  if (assignees && assignees.length > 0 && assignees[0]) {
    names = assignees.reduce((acc, assignee) => {
      const { employee = {}, company_staff = {}, name } = assignee;
      const assigneeName = employee.name || company_staff.name || name;
      if (!assigneeName) return acc;
      return [...acc, assigneeName];
    }, []);
  } else if (offer) {
    if (offer.preview_link) {
      names.push(offer.preview_link.name);
    } else if (offer.offer_signers) {
      names = offer.offer_signers.map((signer) => signer.name);
    } else {
      names = [];
    }
  } else {
    return null;
  }
  const masterAssignee = assignees.find((item) => item.is_master === true);
  if (masterAssignee) names = [masterAssignee.company_staff.name];
  if (names.length === 0) return null;
  if (names.length === 1) {
    return names.map((name, idx) => (
      <Text
        key={`name-${idx}`}
        fontSize="10px"
        semibold
        color="#A3A3A3"
        mt="4px"
      >
        {name}
      </Text>
    ));
  }
  if (!expand) {
    return (
      <Flex
        onClick={(e) => {
          e.stopPropagation();
          setExpand(true);
        }}
      >
        <Text
          title={names.join(', ')}
          fontSize="10px"
          semibold
          color="#A3A3A3"
          mt="4px"
        >
          {names[0]}
          {' '}
          and
          {names.length - 1}
          {' '}
          others...
        </Text>
      </Flex>
    );
  }
  return (
    <Flex
      flexDirection="column"
      onClick={(e) => {
        e.stopPropagation();
        setExpand(false);
      }}
    >
      {names.map((name) => (
        <Text fontSize="10px" semibold color="#A3A3A3" mt="4px">
          {name}
        </Text>
      ))}
    </Flex>
  );
}

const isCompanyDocumentAction = (action) => {
  const { action_type } = action;
  return (
    action_type === 'employee_sign_company_document'
    || action_type === 'hr_sign_company_document'
  );
};

function ActionList({ actions, selectedActionId, onSelect }) {
  return (
    <Flex
      bg="white"
      borderRadius={5}
      p={20}
      pt={[0, 55]}
      flexDirection="column"
    >
      {actions.map((action, idx) => {
        const statusBadge = (() => {
          let backgroundColor;
          backgroundColor = action.status === 'not_started'
            || action.status === 'not_ready'
            || action.status === 'redo'
            || action.status === 'preparing'
            ? '#fa964d'
            : '#2dc294';
          const statusText = actionStatusNameMapping[action.status]
            || capitializeString((action.status || '').split('_').join(' '));
          return (
            <ActionStatus key={idx} bg={backgroundColor}>
              {statusText}
            </ActionStatus>
          );
        })();

        const renderMicroserviceActionNames = (action) => {
          let actionName = action.name;
          if (action.module_name === 'Chick-fil-A HR/Payroll' && actionName === 'New hire submission') {
            actionName = 'Chick-Fil-A HR Payroll';
          }
          return actionName;
        };

        const renderActionName = (action) => {
          switch (action.action_type) {
            case 'w4_form':
              return 'Form W-4';
            case 'employee_fill_i9_form':
              return 'Form I-9';
            case 'employee_fill_us_state_tax_form':
              return 'State Tax Withholding';
            case 'microservice_action':
              return renderMicroserviceActionNames(action);
            case 'formi9_section1':
              return 'Everify (FormI9.com) Section 1';
            case 'formi9_section2':
              return 'Everify (FormI9.com) Section 2';
            default:
              return action.name;
          }
        };

        const actionName = renderActionName(action) || _.capitalize(_.startCase(action.action_type));
        const selected = action.id === selectedActionId;
        const actionNameClassName = classNames({
          'company-documents-name': isCompanyDocumentAction(action),
        });
        const popOverClassName = classNames('company-documents-popover', {
          visible: isCompanyDocumentAction(action),
          selected,
        });

        return (
          <S.ActionWrap
            key={idx}
            selected={selected}
            onClick={() => {
              onSelect(action.id);
            }}
          >
            {statusBadge}
            <Text fontSize="10px" color="#A3A3A3">
              Step
              {' '}
              {idx + 1}
            </Text>
            <Tooltip
              placement="top"
              overlay={actionName}
              overlayClassName={popOverClassName}
            >
              <Text fontSize="14px" className={actionNameClassName}>
                {actionName}
              </Text>
            </Tooltip>
            <AssigneeList assignees={action.assignees} offer={action.offer} />
          </S.ActionWrap>
        );
      })}
    </Flex>
  );
}

export default ActionList;
